export let czechLocaleText = {
	// for filter panel
	page: 'Strana',
	more: 'Více',
	to: 'do',
	of: 'z',
	next: 'následující',
	last: 'poslední',
	first: 'první',
	previous: 'předchozí',
	loadingOoo: 'Načítám...',

	// for set filter
	selectAll: 'Vybrat vše',
	searchOoo: 'Vyhledat...',
	blanks: 'Prázdné',

	// for number filter and text filter
	filterOoo: 'Hledat...',
	applyFilter: 'Filtrovat...',
	equals: 'Je rovno',
	notEquals: 'Není rovno',

	// for number filter
	lessThan: 'Menší',
	greaterThan: 'Větší',
	lessThanOrEqual: 'Menší nebo rovno',
	greaterThanOrEqual: 'Větší nebo rovno',
	inRange: 'V rozmezí',

	// for text filter
	contains: 'Obsahuje',
	notContains: 'Neobsahuje',
	startsWith: 'Začíná na',
	endsWith: 'Končí na',

	// the header of the default group column
	group: 'Skupina',

	// tool panel
	columns: 'Sloupce',
	filters: 'Filtry',
	rowGroupColumns: 'laPivot Cols',
	rowGroupColumnsEmptyMessage: 'Přetáhnout sloupce k seskupení',
	valueColumns: 'laValue Cols',
	pivotMode: 'Pivot mód',
	groups: 'Skupiny řádků',
	values: 'Hodnoty sloupců',
	pivots: 'Názvy sloupců',
	valueColumnsEmptyMessage: 'Přetáhnout sloupce k agregaci',
	pivotColumnsEmptyMessage: 'Přetáhnout sloupce pro nastavení hodnot',
	toolPanelButton: 'la tool panel',

	// other
	noRowsToShow: 'žádné řádky',

	// enterprise menu
	pinColumn: 'Připnout sloupec',
	valueAggregation: 'laValue Agg',
	autosizeThiscolumn: 'Automatická šířka',
	autosizeAllColumns: 'Automatická šířka všech sloupců',
	groupBy: 'Seskupit dle',
	ungroupBy: 'Zrušit seskupení dle',
	resetColumns: 'Výchozí nastavení',
	expandAll: 'Rozbalit vše',
	collapseAll: 'Sbalit vše',
	toolPanel: 'laTool Panelo',
	export: 'Export',
	csvExport: 'Export do CSV',
	excelExport: 'Export do XLS',

	selectedRowCount: 'Vybráno',
	rowAndFilteredCount: 'Počet řádků',

	// enterprise menu pinning
	pinLeft: 'Připnout <<',
	pinRight: 'Připnout >>',
	noPin: 'Zrušit připnutí <>',

	// enterprise menu aggregation and status bar
	sum: 'Suma',
	min: 'Min',
	max: 'Max',
	none: 'laNone',
	count: 'Počet',
	average: 'Průměr',

	// standard menu
	copy: 'Kopírovat',
	copyWithHeaders: 'Kopírovat s hlavičkou',
	ctrlC: 'ctrl + C',
	paste: 'Vložit',
	ctrlV: 'ctrl + V'
};
